import styled from "styled-components"
import Constants from "../../constants"

export default styled.h1`
  font-family: "Work Sans";
  font-weight: 300;
  font-size: 2.5em;
  color: ${Constants.Colors.keBasePurple};
  text-transform: uppercase;

  > small {
    font-size: 0.8em;
    color: ${Constants.Colors.keBlack};
  }

  @media (min-width: 48rem) {
    text-align: center;
  }
`
